import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import SplitsConfirmationPage from './SplitsConfirmationPage';
import SplitsErrorPage from './SplitsError';
import SplitsPage from './SplitsPage';
import SplitsSuccessPage from './SplitsSuccessPage';

const SplitsRoute: FuseRouteItemType[] = [
  {
    path: 'splits',
    element: <SplitsPage />,
    auth: null,
  },
  {
    path: '/splits/confirmation',
    element: <SplitsConfirmationPage />,
    auth: null,
  },
  {
    path: 'splits/success',
    element: <SplitsSuccessPage />,
    auth: null,
  },
  {
    path: 'splits/error',
    element: <SplitsErrorPage />,
    auth: null,
  },
];

export default SplitsRoute;
